export function renderFinancialStatementsTable({
  incomeDate,
  incomeEbitda,
  incomeRevenue,
  incomeFinalLink,
  incomeNetIncome,
  incomeGrossProfit,
  incomeReportedDate,
  incomeOperatingIncome,
  cashFlowDate,
  cashFlowFinalLink,
  cashFlowFreeCashflow,
  cashFlowReportedDate,
  cashFlowFinancingCashflow,
  cashFlowInvestingCashflow,
  cashFlowOperatingCashflow,
  balanceSheetDate,
  balanceSheetFinalLink,
  balanceSheetTotalAssets,
  balanceSheetTotalEquity,
  balanceSheetReportedDate,
  balanceSheetRetainedEarnings,
  balanceSheetTotalLiabilities,
  balanceSheetCashAndEquivalents,
  isValidFieldAPI,
  formatCurrencyAPI,
}: {
  incomeDate: any;
  incomeEbitda: any;
  incomeRevenue: any;
  incomeFinalLink: any;
  incomeNetIncome: any;
  incomeGrossProfit: any;
  incomeReportedDate: any;
  incomeOperatingIncome: any;
  cashFlowDate: any;
  cashFlowFinalLink: any;
  cashFlowFreeCashflow: any;
  cashFlowReportedDate: any;
  cashFlowFinancingCashflow: any;
  cashFlowInvestingCashflow: any;
  cashFlowOperatingCashflow: any;
  balanceSheetDate: any;
  balanceSheetFinalLink: any;
  balanceSheetTotalAssets: any;
  balanceSheetTotalEquity: any;
  balanceSheetReportedDate: any;
  balanceSheetRetainedEarnings: any;
  balanceSheetTotalLiabilities: any;
  balanceSheetCashAndEquivalents: any;
  isValidFieldAPI: Function;
  formatCurrencyAPI: Function;
}) {
  const hasIncomeData =
    isValidFieldAPI(incomeRevenue) ||
    isValidFieldAPI(incomeNetIncome) ||
    isValidFieldAPI(incomeGrossProfit);
  const hasCashFlowData =
    isValidFieldAPI(cashFlowOperatingCashflow) ||
    isValidFieldAPI(cashFlowFreeCashflow);
  const hasBalanceSheetData =
    isValidFieldAPI(balanceSheetTotalAssets) ||
    isValidFieldAPI(balanceSheetTotalEquity);

  if (!hasIncomeData && !hasCashFlowData && !hasBalanceSheetData) {
    return null;
  }

  return (
    <div
      style={{
        background: "white",
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        marginBottom: 16,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: 16,
          background: "#fef3c7",
          borderBottom: "1px solid #fde68a",
        }}
      >
        <span style={{ color: "#d97706", fontSize: 16 }}>📊</span>
        <h4
          style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "#d97706" }}
        >
          Financial Statements
        </h4>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: 12,
          padding: 16,
        }}
      >
        {hasIncomeData && (
          <div
            style={{
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: 8,
              padding: 10,
            }}
          >
            <h5
              style={{
                margin: "0 0 10px 0",
                fontSize: 13,
                fontWeight: 600,
                color: "#374151",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <span style={{ color: "#3b82f6" }}>📈</span>
              Income Statement
            </h5>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 6,
                marginBottom: 10,
              }}
            >
              {isValidFieldAPI(incomeDate) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 11,
                    color: "#64748b",
                  }}
                >
                  <span>Date:</span>
                  <span>{new Date(incomeDate).toLocaleDateString()}</span>
                </div>
              )}
              {isValidFieldAPI(incomeReportedDate) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 11,
                    color: "#64748b",
                  }}
                >
                  <span>Reported:</span>
                  <span>
                    {new Date(incomeReportedDate).toLocaleDateString()}
                  </span>
                </div>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {isValidFieldAPI(incomeRevenue) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#dbeafe",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Revenue
                  </span>
                  <span
                    style={{ fontSize: 12, fontWeight: 700, color: "#1e40af" }}
                  >
                    {formatCurrencyAPI(incomeRevenue)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(incomeGrossProfit) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#eff6ff",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Gross Profit
                  </span>
                  <span
                    style={{ fontSize: 12, fontWeight: 700, color: "#2563eb" }}
                  >
                    {formatCurrencyAPI(incomeGrossProfit)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(incomeOperatingIncome) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#faf5ff",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Operating Income
                  </span>
                  <span
                    style={{ fontSize: 12, fontWeight: 700, color: "#8b5cf6" }}
                  >
                    {formatCurrencyAPI(incomeOperatingIncome)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(incomeNetIncome) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#eff6ff",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Net Income
                  </span>
                  <span
                    style={{ fontSize: 12, fontWeight: 700, color: "#2563eb" }}
                  >
                    {formatCurrencyAPI(incomeNetIncome)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(incomeEbitda) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#fef2f2",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    EBITDA
                  </span>
                  <span
                    style={{ fontSize: 12, fontWeight: 700, color: "#dc2626" }}
                  >
                    {formatCurrencyAPI(incomeEbitda)}
                  </span>
                </div>
              )}
            </div>
            {isValidFieldAPI(incomeFinalLink) && (
              <div
                style={{
                  marginTop: 12,
                  paddingTop: 8,
                  borderTop: "1px solid #e2e8f0",
                }}
              >
                <a
                  href={incomeFinalLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: 12,
                    color: "#3b82f6",
                    textDecoration: "none",
                  }}
                >
                  📄 SEC Filing →
                </a>
              </div>
            )}
          </div>
        )}

        {hasCashFlowData && (
          <div
            style={{
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: 8,
              padding: 10,
            }}
          >
            <h5
              style={{
                margin: "0 0 10px 0",
                fontSize: 13,
                fontWeight: 600,
                color: "#374151",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <span style={{ color: "#0ea5e9" }}>💧</span>
              Cash Flow Statement
            </h5>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 6,
                marginBottom: 10,
              }}
            >
              {isValidFieldAPI(cashFlowDate) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 11,
                    color: "#64748b",
                  }}
                >
                  <span>Date:</span>
                  <span>{new Date(cashFlowDate).toLocaleDateString()}</span>
                </div>
              )}
              {isValidFieldAPI(cashFlowReportedDate) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 11,
                    color: "#64748b",
                  }}
                >
                  <span>Reported:</span>
                  <span>
                    {new Date(cashFlowReportedDate).toLocaleDateString()}
                  </span>
                </div>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {isValidFieldAPI(cashFlowOperatingCashflow) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#f0fdf4",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Operating Cash Flow
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color:
                        cashFlowOperatingCashflow < 0 ? "#dc2626" : "#059669",
                    }}
                  >
                    {formatCurrencyAPI(cashFlowOperatingCashflow)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(cashFlowInvestingCashflow) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#eff6ff",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Investing Cash Flow
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color:
                        cashFlowInvestingCashflow < 0 ? "#dc2626" : "#2563eb",
                    }}
                  >
                    {formatCurrencyAPI(cashFlowInvestingCashflow)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(cashFlowFinancingCashflow) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#faf5ff",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Financing Cash Flow
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color:
                        cashFlowFinancingCashflow < 0 ? "#dc2626" : "#8b5cf6",
                    }}
                  >
                    {formatCurrencyAPI(cashFlowFinancingCashflow)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(cashFlowFreeCashflow) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#f0fdf4",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Free Cash Flow
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: cashFlowFreeCashflow < 0 ? "#dc2626" : "#059669",
                    }}
                  >
                    {formatCurrencyAPI(cashFlowFreeCashflow)}
                  </span>
                </div>
              )}
            </div>
            {isValidFieldAPI(cashFlowFinalLink) && (
              <div
                style={{
                  marginTop: 10,
                  paddingTop: 8,
                  borderTop: "1px solid #e2e8f0",
                }}
              >
                <a
                  href={cashFlowFinalLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: 12,
                    color: "#3b82f6",
                    textDecoration: "none",
                  }}
                >
                  📄 SEC Filing →
                </a>
              </div>
            )}
          </div>
        )}

        {hasBalanceSheetData && (
          <div
            style={{
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: 8,
              padding: 10,
            }}
          >
            <h5
              style={{
                margin: "0 0 10px 0",
                fontSize: 13,
                fontWeight: 600,
                color: "#374151",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <span style={{ color: "#8b5cf6" }}>⚖️</span>
              Balance Sheet
            </h5>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 6,
                marginBottom: 10,
              }}
            >
              {isValidFieldAPI(balanceSheetDate) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 11,
                    color: "#64748b",
                  }}
                >
                  <span>Date:</span>
                  <span>{new Date(balanceSheetDate).toLocaleDateString()}</span>
                </div>
              )}
              {isValidFieldAPI(balanceSheetReportedDate) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 11,
                    color: "#64748b",
                  }}
                >
                  <span>Reported:</span>
                  <span>
                    {new Date(balanceSheetReportedDate).toLocaleDateString()}
                  </span>
                </div>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {isValidFieldAPI(balanceSheetTotalAssets) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#f0fdf4",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Total Assets
                  </span>
                  <span
                    style={{ fontSize: 12, fontWeight: 700, color: "#059669" }}
                  >
                    {formatCurrencyAPI(balanceSheetTotalAssets)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(balanceSheetTotalLiabilities) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#fef2f2",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Total Liabilities
                  </span>
                  <span
                    style={{ fontSize: 12, fontWeight: 700, color: "#dc2626" }}
                  >
                    {formatCurrencyAPI(balanceSheetTotalLiabilities)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(balanceSheetTotalEquity) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#eff6ff",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Total Equity
                  </span>
                  <span
                    style={{ fontSize: 12, fontWeight: 700, color: "#2563eb" }}
                  >
                    {formatCurrencyAPI(balanceSheetTotalEquity)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(balanceSheetRetainedEarnings) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#faf5ff",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Retained Earnings
                  </span>
                  <span
                    style={{ fontSize: 12, fontWeight: 700, color: "#8b5cf6" }}
                  >
                    {formatCurrencyAPI(balanceSheetRetainedEarnings)}
                  </span>
                </div>
              )}
              {isValidFieldAPI(balanceSheetCashAndEquivalents) && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 6,
                    background: "#f0fdf4",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#374151", fontWeight: 500 }}
                  >
                    Cash & Equivalents
                  </span>
                  <span
                    style={{ fontSize: 12, fontWeight: 700, color: "#059669" }}
                  >
                    {formatCurrencyAPI(balanceSheetCashAndEquivalents)}
                  </span>
                </div>
              )}
            </div>
            {isValidFieldAPI(balanceSheetFinalLink) && (
              <div
                style={{
                  marginTop: 10,
                  paddingTop: 8,
                  borderTop: "1px solid #e2e8f0",
                }}
              >
                <a
                  href={balanceSheetFinalLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: 12,
                    color: "#3b82f6",
                    textDecoration: "none",
                  }}
                >
                  📄 SEC Filing →
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export function renderAnalystCoverageTable({
  totalAnalysts,
  priceTargetLow,
  priceTargetHigh,
  priceTargetUpside,
  priceTargetAverage,
  recommendationsBuy,
  recommendationsHold,
  recommendationsSell,
  recommendationsStrongBuy,
  recommendationsStrongSell,
  recentActions,
  isValidFieldAPI,
  formatCurrencyAPI,
  formatPercentageAPI,
}: {
  totalAnalysts: number;
  priceTargetLow: number | null;
  priceTargetHigh: number | null;
  priceTargetUpside: number | null;
  priceTargetAverage: number | null;
  recommendationsBuy: number;
  recommendationsHold: number;
  recommendationsSell: number;
  recommendationsStrongBuy: number;
  recommendationsStrongSell: number;
  recentActions: any[];
  isValidFieldAPI: Function;
  formatCurrencyAPI: Function;
  formatPercentageAPI: Function;
}) {
  const hasData = isValidFieldAPI(priceTargetAverage) || totalAnalysts > 0;
  if (!hasData) {
    return null;
  }

  return (
    <div
      style={{
        background: "white",
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        marginBottom: 16,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: 16,
          background: "#f0f9ff",
          borderBottom: "1px solid #c7d2fe",
        }}
      >
        <span style={{ color: "#6366f1", fontSize: 16 }}>👥</span>
        <h4
          style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "#6366f1" }}
        >
          Analyst Coverage
        </h4>
      </div>

      <div style={{ padding: 16 }}>
        {totalAnalysts > 0 && (
          <div
            style={{
              textAlign: "center",
              marginBottom: 16,
              padding: 12,
              background: "#f1f5f9",
              borderRadius: 8,
              border: "1px solid #e2e8f0",
            }}
          >
            <span style={{ fontSize: 14, color: "#475569", fontWeight: 500 }}>
              Total Coverage:{" "}
            </span>
            <span style={{ fontSize: 18, fontWeight: 700, color: "#334155" }}>
              {totalAnalysts} analysts
            </span>
          </div>
        )}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 16,
            marginBottom: 16,
          }}
        >
          {(isValidFieldAPI(priceTargetAverage) ||
            isValidFieldAPI(priceTargetHigh) ||
            isValidFieldAPI(priceTargetLow)) && (
            <div
              style={{
                background: "#f8fafc",
                padding: 16,
                borderRadius: 8,
                border: "1px solid #e2e8f0",
              }}
            >
              <h5
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#334155",
                  margin: "0 0 12px 0",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span style={{ fontSize: 14 }}>🎯</span>
                Price Targets
              </h5>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: 12,
                  marginBottom: 12,
                }}
              >
                {isValidFieldAPI(priceTargetAverage) && (
                  <div
                    style={{
                      background: "#dbeafe",
                      border: "1px solid #93c5fd",
                      padding: 12,
                      borderRadius: 8,
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11,
                        color: "#1e40af",
                        fontWeight: 500,
                        marginBottom: 4,
                      }}
                    >
                      Average
                    </div>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: "#1e3a8a",
                      }}
                    >
                      {formatCurrencyAPI(priceTargetAverage)}
                    </div>
                  </div>
                )}
                {isValidFieldAPI(priceTargetHigh) && (
                  <div
                    style={{
                      background: "#dcfce7",
                      border: "1px solid #86efac",
                      padding: 12,
                      borderRadius: 8,
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11,
                        color: "#15803d",
                        fontWeight: 500,
                        marginBottom: 4,
                      }}
                    >
                      High
                    </div>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: "#14532d",
                      }}
                    >
                      {formatCurrencyAPI(priceTargetHigh)}
                    </div>
                  </div>
                )}
                {isValidFieldAPI(priceTargetLow) && (
                  <div
                    style={{
                      background: "#fee2e2",
                      border: "1px solid #fca5a5",
                      padding: 12,
                      borderRadius: 8,
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11,
                        color: "#dc2626",
                        fontWeight: 500,
                        marginBottom: 4,
                      }}
                    >
                      Low
                    </div>
                    <div
                      style={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: "#991b1b",
                      }}
                    >
                      {formatCurrencyAPI(priceTargetLow)}
                    </div>
                  </div>
                )}
              </div>

              {isValidFieldAPI(priceTargetUpside) && (
                <div
                  style={{
                    padding: 8,
                    background: "#f0f9ff",
                    border: "1px solid #bae6fd",
                    borderRadius: 6,
                    textAlign: "center",
                  }}
                >
                  <span
                    style={{ fontSize: 12, color: "#0369a1", fontWeight: 500 }}
                  >
                    Upside Potential:{" "}
                  </span>
                  <span
                    style={{ fontSize: 13, fontWeight: 700, color: "#0c4a6e" }}
                  >
                    {formatPercentageAPI(priceTargetUpside)}
                  </span>
                </div>
              )}
            </div>
          )}

          <div
            style={{
              background: "#f8fafc",
              padding: 16,
              borderRadius: 8,
              border: "1px solid #e2e8f0",
            }}
          >
            <h5
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#334155",
                margin: "0 0 12px 0",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <span style={{ fontSize: 14 }}>📊</span>
              Recommendations
            </h5>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {recommendationsStrongBuy > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 8,
                    background: "#065f46",
                    color: "white",
                    borderRadius: 6,
                  }}
                >
                  <span style={{ fontSize: 13, fontWeight: 500 }}>
                    Strong Buy
                  </span>
                  <span style={{ fontSize: 14, fontWeight: 700 }}>
                    {recommendationsStrongBuy}
                  </span>
                </div>
              )}
              {recommendationsBuy > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 8,
                    background: "#f0fdf4",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 13, color: "#374151", fontWeight: 500 }}
                  >
                    Buy
                  </span>
                  <span
                    style={{ fontSize: 14, fontWeight: 700, color: "#059669" }}
                  >
                    {recommendationsBuy}
                  </span>
                </div>
              )}
              {recommendationsHold > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 8,
                    background: "#fef3c7",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 13, color: "#374151", fontWeight: 500 }}
                  >
                    Hold
                  </span>
                  <span
                    style={{ fontSize: 14, fontWeight: 700, color: "#d97706" }}
                  >
                    {recommendationsHold}
                  </span>
                </div>
              )}
              {recommendationsSell > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 8,
                    background: "#fef2f2",
                    borderRadius: 6,
                  }}
                >
                  <span
                    style={{ fontSize: 13, color: "#374151", fontWeight: 500 }}
                  >
                    Sell
                  </span>
                  <span
                    style={{ fontSize: 14, fontWeight: 700, color: "#dc2626" }}
                  >
                    {recommendationsSell}
                  </span>
                </div>
              )}
              {recommendationsStrongSell > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 8,
                    background: "#7f1d1d",
                    color: "white",
                    borderRadius: 6,
                  }}
                >
                  <span style={{ fontSize: 13, fontWeight: 500 }}>
                    Strong Sell
                  </span>
                  <span style={{ fontSize: 14, fontWeight: 700 }}>
                    {recommendationsStrongSell}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {Array.isArray(recentActions) && recentActions.length > 0 && (
          <div
            style={{
              background: "#f8fafc",
              padding: 16,
              borderRadius: 8,
              border: "1px solid #e2e8f0",
            }}
          >
            <h5
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#334155",
                margin: "0 0 12px 0",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <span style={{ fontSize: 14 }}>📈</span>
              Recent Actions
            </h5>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {recentActions.slice(0, 5).map((action, idx) => {
                const date = new Date(action.date).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                });
                const actionColor =
                  action.action === "upgrade" || action.action === "initialise"
                    ? "#059669"
                    : action.action === "downgrade"
                      ? "#dc2626"
                      : "#6b7280";

                return (
                  <div
                    key={idx}
                    style={{
                      padding: 12,
                      background: "white",
                      border: "1px solid #e5e7eb",
                      borderRadius: 8,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 6,
                      }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          color: "#6b7280",
                          fontWeight: 500,
                        }}
                      >
                        {date}
                      </span>
                      <span
                        style={{
                          fontSize: 12,
                          padding: "4px 8px",
                          background: actionColor,
                          color: "white",
                          borderRadius: 12,
                          fontWeight: 500,
                          textTransform: "capitalize",
                        }}
                      >
                        {action.action}
                      </span>
                    </div>
                    {action.firm && (
                      <div
                        style={{
                          fontSize: 13,
                          color: "#374151",
                          fontWeight: 600,
                          marginBottom: 4,
                        }}
                      >
                        {action.firm}
                      </div>
                    )}
                    <div style={{ fontSize: 12, color: "#6b7280" }}>
                      {action.fromGrade && action.toGrade
                        ? `${action.fromGrade} → ${action.toGrade}`
                        : action.toGrade || "Grade updated"}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export function organizationRelevanceTable(
  relevance: any,
  potentialRisks: any,
  potentialOpportunities: any,
  organizationName: string | undefined
) {
  const risksArray = Array.isArray(potentialRisks) ? potentialRisks : [];
  const opportunitiesArray = Array.isArray(potentialOpportunities)
    ? potentialOpportunities
    : [];

  const hasRelevance = relevance && isValidFieldAPI(relevance);
  const hasRisks = risksArray.length > 0;
  const hasOpportunities = opportunitiesArray.length > 0;

  if (!hasRelevance && !hasRisks && !hasOpportunities) return null;

  const orgNameDisplay = organizationName || "Organization";

  function RelevanceBadge({ relevanceLevel }: { relevanceLevel: string }) {
    if (!relevanceLevel || ["N/A", "n/a", ""].includes(relevanceLevel.trim())) {
      return null;
    }

    const level = relevanceLevel.toLowerCase().trim();
    let badgeColor = "#3b82f6"; // Default blue
    if (level === "high")
      badgeColor = "#16a34a"; // Green
    else if (level === "moderate" || level === "medium")
      badgeColor = "#f59e0b"; // Orange/Yellow
    else if (level === "low") badgeColor = "#6b7280"; // Gray

    const style: React.CSSProperties = {
      backgroundColor: badgeColor,
      color: "#ffffff",
      padding: "2px 8px",
      borderRadius: 12,
      fontSize: 12,
      fontWeight: 600,
      textTransform: "uppercase" as const,
      marginLeft: 8,
      display: "inline-block",
    };

    return <span style={style}>{relevanceLevel.toUpperCase()}</span>;
  }

  return (
    <section
      aria-labelledby="organization-relevance-title"
      style={{
        background: "white",
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        marginBottom: 16,
        overflow: "hidden",
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: 16,
          background: "#ecfdf5",
          borderBottom: "1px solid #bbf7d0",
        }}
      >
        <span style={{ color: "#059669", fontSize: 16 }} aria-hidden="true">
          🎯
        </span>
        <h4
          id="organization-relevance-title"
          style={{
            margin: 0,
            fontSize: 16,
            fontWeight: 600,
            color: "#059669",
            display: "flex",
            alignItems: "center",
          }}
        >
          Relevance for {orgNameDisplay}
          {hasRelevance && <RelevanceBadge relevanceLevel={relevance} />}
        </h4>
      </header>

      {(hasRisks || hasOpportunities) && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 16,
            padding: 16,
          }}
        >
          {hasRisks && (
            <div
              style={{
                background: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 8,
                padding: 16,
              }}
            >
              <h5
                style={{
                  margin: "0 0 12px 0",
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#991b1b",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span style={{ fontSize: 14 }} aria-hidden="true">
                  ⚠️
                </span>
                Potential Risks
              </h5>
              <ul
                style={{
                  margin: 0,
                  paddingLeft: 16,
                  color: "#dc2626",
                  fontSize: 13,
                  lineHeight: 1.5,
                }}
              >
                {risksArray.map((risk, i) => {
                  const text = risk?.risk || risk || (
                    <span style={{ color: "#9ca3af" }}>Not Available</span>
                  );
                  return (
                    <li key={i} style={{ marginBottom: 6 }}>
                      {text}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          {hasOpportunities && (
            <div
              style={{
                background: "#f0fdf4",
                border: "1px solid #bbf7d0",
                borderRadius: 8,
                padding: 16,
              }}
            >
              <h5
                style={{
                  margin: "0 0 12px 0",
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#166534",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span style={{ fontSize: 14 }} aria-hidden="true">
                  🚀
                </span>
                Potential Opportunities
              </h5>
              <ul
                style={{
                  margin: 0,
                  paddingLeft: 16,
                  color: "#16a34a",
                  fontSize: 13,
                  lineHeight: 1.5,
                }}
              >
                {opportunitiesArray.map((opportunity, i) => {
                  const text = opportunity?.opportunity || opportunity || (
                    <span style={{ color: "#9ca3af" }}>Not Available</span>
                  );
                  return (
                    <li key={i} style={{ marginBottom: 6 }}>
                      {text}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      )}
    </section>
  );
}

function RiskLevelBadge({ level }: { level: string }) {
  if (!level || level === "N/A" || level.trim() === "") return null;

  const levelLower = level.toLowerCase();
  let style = {};
  if (levelLower === "low") {
    style = { backgroundColor: "#16a34a", color: "white" };
  } else if (levelLower === "moderate" || levelLower === "medium") {
    style = { backgroundColor: "#f59e0b", color: "white" };
  } else if (levelLower === "high") {
    style = { backgroundColor: "#dc2626", color: "white" };
  } else {
    style = { backgroundColor: "#6b7280", color: "white" };
  }

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 12px",
        borderRadius: 16,
        fontSize: 12,
        fontWeight: 600,
        textTransform: "uppercase",
        ...style,
      }}
    >
      {level.toUpperCase()}
    </span>
  );
}

export function FinancialFundamentalsTable({
  annualEarnings = [],
  annualGrowth,
  quarterlyGrowth,
  epsGrowth,
  lastEarningsDate,
  nextEarningsDate,
  quarterlyEarnings = [],
  riskLevel,
  keyRisks = [],
  opportunities = [],
  marginsQuarterly = [],
  revenueQuarterly = [],
}: {
  annualEarnings?: any[];
  annualGrowth?: any;
  quarterlyGrowth?: any;
  epsGrowth?: any;
  lastEarningsDate?: any;
  nextEarningsDate?: any;
  quarterlyEarnings?: any[];
  riskLevel?: any;
  keyRisks?: any[];
  opportunities?: any[];
  marginsQuarterly?: any[];
  revenueQuarterly?: any[];
}) {
  const hasEarningsData =
    hasValidEarningsContent(annualEarnings, quarterlyEarnings) ||
    isValidFieldAPI(annualGrowth, "percentage") ||
    isValidFieldAPI(quarterlyGrowth, "percentage") ||
    isValidFieldAPI(lastEarningsDate) ||
    isValidFieldAPI(nextEarningsDate);
  const hasRiskData = hasValidRiskContent(keyRisks, opportunities, riskLevel);
  const hasTrendData = hasValidTrendContent(marginsQuarterly, revenueQuarterly);

  const missingData = [];
  if (!hasEarningsData) missingData.push("Earnings Performance");
  if (!hasRiskData) missingData.push("Risk Analysis");
  if (!hasTrendData) missingData.push("Financial Trends");

  if (!hasEarningsData && !hasRiskData && !hasTrendData) return null;

  const availableSections = [hasEarningsData, hasRiskData, hasTrendData].filter(
    Boolean
  ).length;
  const gridColumns =
    availableSections === 1
      ? "1fr"
      : availableSections === 2
        ? "repeat(2, 1fr)"
        : "repeat(auto-fit, minmax(350px, 1fr))";

  return (
    <section
      aria-labelledby="financial-fundamentals-title"
      style={{
        background: "white",
        border: "1px solid #e5e7eb",
        borderRadius: 12,
        marginBottom: 16,
        overflow: "hidden",
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: 16,
          background: "#fef7ff",
          borderBottom: "1px solid #f3e8ff",
        }}
      >
        <span style={{ color: "#8b5cf6", fontSize: 16 }} aria-hidden="true">
          📊
        </span>
        <h4
          id="financial-fundamentals-title"
          style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "#8b5cf6" }}
        >
          Financial Fundamentals
        </h4>
      </header>

      <div style={{ padding: 16 }}>
        {availableSections > 0 && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: gridColumns,
              gap: 16,
              marginBottom: missingData.length > 0 ? 16 : 0,
            }}
          >
            {hasEarningsData && (
              <div
                style={{
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: 8,
                  padding: 16,
                }}
              >
                <h5
                  style={{
                    margin: "0 0 12px 0",
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#374151",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <span style={{ color: "#10b981" }} aria-hidden="true">
                    💰
                  </span>
                  Earnings Performance
                </h5>
                {Array.isArray(annualEarnings) && annualEarnings.length > 0 && (
                  <div style={{ marginBottom: 12 }}>
                    <h6
                      style={{
                        margin: "0 0 8px 0",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#6b7280",
                      }}
                    >
                      Annual Earnings
                    </h6>
                    {annualEarnings
                      .slice(0, 3)
                      .map((earning: any, i: number) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: 8,
                            background: "#ecfdf5",
                            borderRadius: 6,
                            marginBottom: 4,
                            fontSize: 13,
                            color: "#374151",
                            fontWeight: 500,
                          }}
                        >
                          <span>{earning.fiscalDateEnding || "N/A"}</span>
                          <span style={{ fontWeight: 700, color: "#059669" }}>
                            EPS:{" "}
                            {isValidFieldAPI(earning.reportedEPS)
                              ? formatCurrencyAPI(earning.reportedEPS)
                              : "N/A"}
                          </span>
                        </div>
                      ))}
                  </div>
                )}
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  {isValidFieldAPI(annualGrowth) && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 8,
                        background: "#dbeafe",
                        borderRadius: 6,
                        fontSize: 13,
                        color: "#374151",
                        fontWeight: 500,
                      }}
                    >
                      <span>Annual Growth</span>
                      <span style={{ fontWeight: 700, color: "#2563eb" }}>
                        {formatPercentageAPI(annualGrowth)}
                      </span>
                    </div>
                  )}
                  {isValidFieldAPI(quarterlyGrowth) && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 8,
                        background: "#fef3c7",
                        borderRadius: 6,
                        fontSize: 13,
                        color: "#374151",
                        fontWeight: 500,
                      }}
                    >
                      <span>Quarterly Growth</span>
                      <span style={{ fontWeight: 700, color: "#d97706" }}>
                        {formatPercentageAPI(quarterlyGrowth)}
                      </span>
                    </div>
                  )}
                  {isValidFieldAPI(epsGrowth) && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 8,
                        background: "#eff6ff",
                        borderRadius: 6,
                        fontSize: 13,
                        color: "#374151",
                        fontWeight: 500,
                      }}
                    >
                      <span>EPS Growth</span>
                      <span style={{ fontWeight: 700, color: "#3b82f6" }}>
                        {formatPercentageAPI(epsGrowth)}
                      </span>
                    </div>
                  )}
                  {isValidFieldAPI(lastEarningsDate) && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 8,
                        background: "#f1f5f9",
                        borderRadius: 6,
                        fontSize: 13,
                        color: "#374151",
                        fontWeight: 500,
                      }}
                    >
                      <span>Last Earnings</span>
                      <span style={{ fontWeight: 700, color: "#334155" }}>
                        {lastEarningsDate}
                      </span>
                    </div>
                  )}
                  {isValidFieldAPI(nextEarningsDate) && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 8,
                        background: "#faf5ff",
                        borderRadius: 6,
                        fontSize: 13,
                        color: "#374151",
                        fontWeight: 500,
                      }}
                    >
                      <span>Next Earnings</span>
                      <span style={{ fontWeight: 700, color: "#8b5cf6" }}>
                        {nextEarningsDate}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {hasRiskData && (
              <div
                style={{
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: 8,
                  padding: 16,
                }}
              >
                <h5
                  style={{
                    margin: "0 0 12px 0",
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#374151",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <span style={{ color: "#f59e0b" }} aria-hidden="true">
                    ⚡
                  </span>
                  Risk Analysis
                </h5>

                {riskLevel && (
                  <div style={{ marginBottom: 16, textAlign: "center" }}>
                    <RiskLevelBadge level={riskLevel} />
                  </div>
                )}

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 12,
                  }}
                >
                  {keyRisks.length > 0 && (
                    <div
                      style={{
                        background: "#fef2f2",
                        border: "1px solid #fca5a5",
                        borderRadius: 6,
                        padding: 12,
                      }}
                    >
                      <h6
                        style={{
                          margin: "0 0 8px 0",
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#dc2626",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <span style={{ color: "#dc2626" }} aria-hidden="true">
                          ⚠️
                        </span>
                        Key Risks
                      </h6>
                      <ul
                        style={{
                          margin: 0,
                          paddingLeft: 16,
                          color: "#dc2626",
                          fontSize: 13,
                          lineHeight: 1.5,
                        }}
                      >
                        {keyRisks.map((risk, i) => (
                          <li key={i} style={{ marginBottom: 4 }}>
                            {risk}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {opportunities.length > 0 && (
                    <div
                      style={{
                        background: "#f0fdf4",
                        border: "1px solid #86efac",
                        borderRadius: 6,
                        padding: 12,
                      }}
                    >
                      <h6
                        style={{
                          margin: "0 0 8px 0",
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#059669",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        <span style={{ color: "#059669" }} aria-hidden="true">
                          🚀
                        </span>
                        Opportunities
                      </h6>
                      <ul
                        style={{
                          margin: 0,
                          paddingLeft: 16,
                          color: "#059669",
                          fontSize: 13,
                          lineHeight: 1.5,
                        }}
                      >
                        {opportunities.map((opportunity, i) => (
                          <li key={i} style={{ marginBottom: 4 }}>
                            {opportunity}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            )}

            {hasTrendData && (
              <div
                style={{
                  background: "#f8fafc",
                  border: "1px solid #e2e8f0",
                  borderRadius: 8,
                  padding: 16,
                }}
              >
                <h5
                  style={{
                    margin: "0 0 12px 0",
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#374151",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <span style={{ color: "#06b6d4" }} aria-hidden="true">
                    📈
                  </span>
                  Financial Trends
                </h5>

                {marginsQuarterly.length > 0 && (
                  <div style={{ marginBottom: 12 }}>
                    <h6
                      style={{
                        margin: "0 0 8px 0",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#6b7280",
                      }}
                    >
                      Margin Trends
                    </h6>
                    {marginsQuarterly
                      .slice(0, 4)
                      .map((margin: any, i: number) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "6px 8px",
                            background: "#f0f9ff",
                            borderRadius: 4,
                            marginBottom: 4,
                            fontSize: 12,
                            color: "#374151",
                          }}
                        >
                          <span>{margin.date || "N/A"}</span>
                          <span style={{ fontWeight: 600, color: "#0284c7" }}>
                            {isValidFieldAPI(margin.net_margin_change)
                              ? formatPercentageAPI(margin.net_margin_change)
                              : "N/A"}
                          </span>
                        </div>
                      ))}
                  </div>
                )}

                {revenueQuarterly.length > 0 && (
                  <div>
                    <h6
                      style={{
                        margin: "0 0 8px 0",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#6b7280",
                      }}
                    >
                      Revenue Growth
                    </h6>
                    {revenueQuarterly
                      .slice(0, 4)
                      .map((revenue: any, i: number) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "6px 8px",
                            background: "#ecfdf5",
                            borderRadius: 4,
                            marginBottom: 4,
                            fontSize: 12,
                            color: "#374151",
                          }}
                        >
                          <span>{revenue.date || "N/A"}</span>
                          <span style={{ fontWeight: 600, color: "#059669" }}>
                            {isValidFieldAPI(revenue.revenue)
                              ? formatCurrencyAPI(revenue.revenue)
                              : "N/A"}
                          </span>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {missingData.length > 0 && (
          <div
            style={{
              padding: "12px 16px",
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: 8,
              fontSize: 13,
              color: "#374151",
              fontStyle: "italic",
            }}
          >
            <span style={{ fontWeight: 600 }}>Data not available for: </span>
            {missingData.join(", ")}
          </div>
        )}
      </div>
    </section>
  );
}

import React from "react";

import { businessHealthScorePalette } from "../../../../Utils/Helper/businessHealth";
import {
  isValidField as isValidFieldAPI,
  extractFlattenedFieldAPI,
  hasValidEarningsContent,
  hasValidRiskContent,
  hasValidTrendContent,
  formatCurrencyAPI,
  formatPercentageAPI,
  formatNumericAPI,
} from "../../../../Utils/WatchlistSummary/validation";

export function FinancialSection({
  data,
  sectionData,
  accountName,
  organizationName,
  onToggleAudio,
}: {
  data: any;
  sectionData: any;
  accountName: string;
  organizationName?: string;
  onToggleAudio?: () => void;
}) {
  if (!data) {
    return <div>No financial data available</div>;
  }

  // Extraction
  const synopsis = extractFlattenedFieldAPI(data, "synopsis", null);
  const confidenceScore = extractFlattenedFieldAPI(
    data,
    "metadata.confidence_score",
    null
  );
  const lastUpdated = extractFlattenedFieldAPI(
    data,
    "metadata.last_updated",
    null
  );
  const dataFreshness = extractFlattenedFieldAPI(
    data,
    "metadata.data_freshness",
    null
  );
  const sources = extractFlattenedFieldAPI(data, "metadata.sources", []);

  const currentPrice = extractFlattenedFieldAPI(
    data,
    "stockData.currentPrice",
    null
  );
  const dayChange = extractFlattenedFieldAPI(data, "stockData.dayChange", null);
  const dayChangePercent = extractFlattenedFieldAPI(
    data,
    "stockData.dayChangePercent",
    null
  );
  const volume = extractFlattenedFieldAPI(data, "stockData.volume", null);
  const avgVolume = extractFlattenedFieldAPI(data, "stockData.avgVolume", null);
  const weekLow52 = extractFlattenedFieldAPI(data, "stockData.weekLow52", null);
  const weekHigh52 = extractFlattenedFieldAPI(
    data,
    "stockData.weekHigh52",
    null
  );
  const eps = extractFlattenedFieldAPI(data, "stockData.eps", null);
  const peRatio = extractFlattenedFieldAPI(data, "stockData.peRatio", null);
  const marketCap = extractFlattenedFieldAPI(data, "stockData.marketCap", null);

  const incomeDate = extractFlattenedFieldAPI(
    data,
    "financial_statements.income.date",
    null
  );
  const incomeEbitda = extractFlattenedFieldAPI(
    data,
    "financial_statements.income.ebitda",
    null
  );
  const incomeRevenue = extractFlattenedFieldAPI(
    data,
    "financial_statements.income.revenue",
    null
  );
  const incomeFinalLink = extractFlattenedFieldAPI(
    data,
    "financial_statements.income.finalLink",
    null
  );
  const incomeNetIncome = extractFlattenedFieldAPI(
    data,
    "financial_statements.income.netIncome",
    null
  );
  const incomeGrossProfit = extractFlattenedFieldAPI(
    data,
    "financial_statements.income.grossProfit",
    null
  );
  const incomeReportedDate = extractFlattenedFieldAPI(
    data,
    "financial_statements.income.reportedDate",
    null
  );
  const incomeOperatingIncome = extractFlattenedFieldAPI(
    data,
    "financial_statements.income.operatingIncome",
    null
  );

  const cashFlowDate = extractFlattenedFieldAPI(
    data,
    "financial_statements.cash_flow.date",
    null
  );
  const cashFlowFinalLink = extractFlattenedFieldAPI(
    data,
    "financial_statements.cash_flow.finalLink",
    null
  );
  const cashFlowFreeCashflow = extractFlattenedFieldAPI(
    data,
    "financial_statements.cash_flow.freeCashflow",
    null
  );
  const cashFlowReportedDate = extractFlattenedFieldAPI(
    data,
    "financial_statements.cash_flow.reportedDate",
    null
  );
  const cashFlowFinancingCashflow = extractFlattenedFieldAPI(
    data,
    "financial_statements.cash_flow.financingCashflow",
    null
  );
  const cashFlowInvestingCashflow = extractFlattenedFieldAPI(
    data,
    "financial_statements.cash_flow.investingCashflow",
    null
  );
  const cashFlowOperatingCashflow = extractFlattenedFieldAPI(
    data,
    "financial_statements.cash_flow.operatingCashflow",
    null
  );

  const balanceSheetDate = extractFlattenedFieldAPI(
    data,
    "financial_statements.balance_sheet.date",
    null
  );
  const balanceSheetFinalLink = extractFlattenedFieldAPI(
    data,
    "financial_statements.balance_sheet.finalLink",
    null
  );
  const balanceSheetTotalAssets = extractFlattenedFieldAPI(
    data,
    "financial_statements.balance_sheet.totalAssets",
    null
  );
  const balanceSheetTotalEquity = extractFlattenedFieldAPI(
    data,
    "financial_statements.balance_sheet.totalEquity",
    null
  );
  const balanceSheetReportedDate = extractFlattenedFieldAPI(
    data,
    "financial_statements.balance_sheet.reportedDate",
    null
  );
  const balanceSheetRetainedEarnings = extractFlattenedFieldAPI(
    data,
    "financial_statements.balance_sheet.retainedEarnings",
    null
  );
  const balanceSheetTotalLiabilities = extractFlattenedFieldAPI(
    data,
    "financial_statements.balance_sheet.totalLiabilities",
    null
  );
  const balanceSheetCashAndEquivalents = extractFlattenedFieldAPI(
    data,
    "financial_statements.balance_sheet.cashAndEquivalents",
    null
  );

  const totalAnalysts = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.recommendations.totalAnalysts",
    0
  );
  const priceTargetLow = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.priceTargets.low",
    null
  );
  const priceTargetHigh = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.priceTargets.high",
    null
  );
  const priceTargetUpside = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.priceTargets.upside",
    null
  );
  const priceTargetAverage = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.priceTargets.average",
    null
  );
  const recommendationsBuy = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.recommendations.buy",
    0
  );
  const recommendationsHold = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.recommendations.hold",
    0
  );
  const recommendationsSell = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.recommendations.sell",
    0
  );
  const recommendationsStrongBuy = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.recommendations.strongBuy",
    0
  );
  const recommendationsStrongSell = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.recommendations.strongSell",
    0
  );
  const recentActions = extractFlattenedFieldAPI(
    data,
    "analyst_coverage.recentActions",
    []
  );

  // Extract organization relevance using flattened paths
  const relevance = extractFlattenedFieldAPI(
    data,
    "organizationContext.relevantToOrganization.relevance",
    null
  );
  const potentialRisks = extractFlattenedFieldAPI(
    data,
    "organizationContext.potentialRisks",
    []
  );
  const potentialOpportunities = extractFlattenedFieldAPI(
    data,
    "organizationContext.potentialOpportunities",
    []
  );

  // Extract fundamentals data fields directly from flattened JSON
  const annualEarnings = extractFlattenedFieldAPI(
    data,
    "fundamentals.earnings.annualEarnings",
    []
  );
  const quarterlyGrowth = extractFlattenedFieldAPI(
    data,
    "fundamentals.earnings.earnings_growth.quarterly",
    null
  );
  const epsGrowth = extractFlattenedFieldAPI(
    data,
    "fundamentals.earnings.earnings_growth.eps_growth",
    null
  );
  const lastEarningsDate = extractFlattenedFieldAPI(
    data,
    "fundamentals.earnings.earnings_growth.lastEarningsDate",
    null
  );
  const nextEarningsDate = extractFlattenedFieldAPI(
    data,
    "fundamentals.earnings.earnings_growth.nextEarningsDate",
    null
  );
  const quarterlyEarnings = extractFlattenedFieldAPI(
    data,
    "fundamentals.earnings.quarterlyEarnings",
    []
  );
  const riskLevel = extractFlattenedFieldAPI(
    data,
    "fundamentals.risk_analysis.risk_level",
    null
  );
  const keyRisks = extractFlattenedFieldAPI(
    data,
    "fundamentals.risk_analysis.key_risks",
    []
  );
  const opportunities = extractFlattenedFieldAPI(
    data,
    "fundamentals.risk_analysis.opportunities",
    []
  );
  const marginsQuarterly = extractFlattenedFieldAPI(
    data,
    "fundamentals.margins_trend_quarterly",
    []
  );
  const revenueQuarterly = extractFlattenedFieldAPI(
    data,
    "fundamentals.revenue_growth_quarterly",
    []
  );

  const healthFlag = sectionData?.sectionHealthFlag || "N/A";
  const relevanceFlag = sectionData?.sectionRelevanceFlag || "N/A";

  // Helper functions: getHealthText, getRelevanceText, badges, score bubble, etc.
  const getHealthText = (flag: string) => {
    switch (flag) {
      case "G":
        return "GREEN";
      case "Y":
        return "YELLOW";
      case "R":
        return "RED";
      default:
        return "N/A";
    }
  };
  const getRelevanceText = (flag: string) => {
    switch (flag) {
      case "H":
        return "HIGH";
      case "M":
        return "MEDIUM";
      case "L":
        return "LOW";
      default:
        return "N/A";
    }
  };
  const formatConfidenceScore = (score: any) => {
    if (score === null || score === undefined) return "N/A";
    if (typeof score === "number")
      return score <= 1
        ? Math.round(score * 100) + "%"
        : Math.round(score) + "%";
    return "N/A";
  };

  const HealthBadge = (flag: string) => {
    const bgColor =
      flag === "G" ? "#16a34a" : flag === "Y" ? "#d97706" : "#dc2626";
    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 12px",
          background: bgColor,
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 500,
          color: "white",
        }}
      >
        <span>Account Health:</span>
        <span style={{ fontWeight: 700 }}>{getHealthText(flag)}</span>
      </div>
    );
  };
  const RelevanceBadge = (flag: string) => {
    const bgColor = "#8b5cf6";
    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 12px",
          background: bgColor,
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 500,
          color: "white",
        }}
      >
        <span>Relevance to Smarsh:</span>
        <span style={{ fontWeight: 700 }}>{getRelevanceText(flag)}</span>
      </div>
    );
  };

  const ScoreBubble = (score: number) => {
    const getScoreColors = (score: number) => businessHealthScorePalette(score);
    const colors = getScoreColors(score);
    return (
      <div
        style={{ position: "relative", width: 48, height: 48, flexShrink: 0 }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: 48,
            height: 48,
            borderRadius: "50%",
            background: colors.outer,
            border: `2px solid ${colors.inner}`,
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 6,
            left: 6,
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: colors.inner,
            border: `1px solid ${colors.score}`,
          }}
        />
        <div
          style={{
            position: "absolute",
            top: -2,
            right: -2,
            width: 20,
            height: 20,
            borderRadius: "50%",
            background: colors.score,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid white",
            color: "white",
            fontSize: 11,
            fontWeight: 700,
            lineHeight: 1,
          }}
        >
          {Math.round(score)}
        </div>
      </div>
    );
  };

  const MetricCard = (
    label: string,
    value: string,
    color = "#1e293b",
    icon: React.ReactNode = null
  ) => (
    <div
      style={{
        padding: 12,
        background: "white",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      <div
        style={{
          fontSize: 12,
          fontWeight: 500,
          color: "#6b7280",
          marginBottom: 4,
        }}
      >
        {label}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          fontSize: 14,
          fontWeight: 600,
          color,
        }}
      >
        {icon && <span style={{ fontSize: 12 }}>{icon}</span>}
        {value}
      </div>
    </div>
  );

  const sourcesText = Array.isArray(sources)
    ? sources
        .map(s => (typeof s === "object" ? s?.name : s))
        .filter(Boolean)
        .join(", ")
    : "N/A";

  // Compose Stock Cards
  const stockCards: React.ReactNode[] = [];
  if (isValidFieldAPI(currentPrice))
    stockCards.push(
      MetricCard("Current Price", formatCurrencyAPI(currentPrice))
    );
  if (isValidFieldAPI(dayChange) || isValidFieldAPI(dayChangePercent)) {
    const changeValue = isValidFieldAPI(dayChange)
      ? formatCurrencyAPI(dayChange)
      : "N/A";
    const percentValue = isValidFieldAPI(dayChangePercent)
      ? ` (${formatPercentageAPI(dayChangePercent)})`
      : "";
    const isPositive = dayChange && dayChange >= 0;
    const color = isPositive ? "#059669" : "#dc2626";
    const icon = isPositive ? "📈" : "📉";
    stockCards.push(
      MetricCard("Day Change", `${changeValue}${percentValue}`, color, icon)
    );
  }
  if (isValidFieldAPI(volume))
    stockCards.push(MetricCard("Volume", formatNumericAPI(volume)));
  if (isValidFieldAPI(avgVolume))
    stockCards.push(MetricCard("Avg Volume", formatNumericAPI(avgVolume)));
  if (isValidFieldAPI(marketCap))
    stockCards.push(MetricCard("Market Cap", formatCurrencyAPI(marketCap)));
  if (isValidFieldAPI(peRatio))
    stockCards.push(MetricCard("P/E Ratio", formatNumericAPI(peRatio)));
  if (isValidFieldAPI(weekLow52) || isValidFieldAPI(weekHigh52)) {
    const lowValue = isValidFieldAPI(weekLow52)
      ? formatCurrencyAPI(weekLow52)
      : "N/A";
    const highValue = isValidFieldAPI(weekHigh52)
      ? formatCurrencyAPI(weekHigh52)
      : "N/A";
    stockCards.push(
      <div
        key="52WRange"
        style={{
          padding: 12,
          background: "white",
          border: "1px solid #e5e7eb",
          borderRadius: 8,
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: 500,
            color: "#6b7280",
            marginBottom: 4,
          }}
        >
          52W Range
        </div>
        <div style={{ fontSize: 14, fontWeight: 600 }}>
          <span style={{ color: "#dc2626" }}>{lowValue}</span>
          <span style={{ color: "#6b7280", margin: "0 4px" }}>-</span>
          <span style={{ color: "#059669" }}>{highValue}</span>
        </div>
      </div>
    );
  }
  if (isValidFieldAPI(eps))
    stockCards.push(MetricCard("EPS", formatCurrencyAPI(eps)));

  return (
    <div className="financial-section-consolidated">
      {/* Header with Score Bubble */}
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        {ScoreBubble(sectionData?.sectionScore || 0)}
        <div>
          <h3 style={{ margin: 0, fontSize: 18, color: "#8b5cf6" }}>
            <strong>{accountName}</strong> - <em>Financial Analysis</em>
          </h3>
        </div>
        <button
          id="financial-audio-btn"
          className="audio-btn"
          title="Play financial audio narration"
          onClick={onToggleAudio}
          style={{
            background: "none",
            border: "none",
            padding: 8,
            borderRadius: 6,
            cursor: "pointer",
            transition: "background-color 0.2s",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="#8b5cf6"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M11 5 6 9H2v6h4l5 4V5ZM15.54 8.46a5 5 0 0 1 0 7.07M19.07 4.93a10 10 0 0 1 0 14.14" />
          </svg>
        </button>
      </div>

      {/* Badges */}
      <div
        style={{
          background: "white",
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          marginTop: 16,
          overflow: "hidden",
          marginBottom: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 12,
            padding: "12px 16px",
            background: "#f8fafc",
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          {HealthBadge(healthFlag)}
          {RelevanceBadge(relevanceFlag)}
        </div>

        {/* Summary */}
        <div style={{ padding: "16px 16px 8px 16px" }}>
          <h4
            style={{
              margin: 0,
              marginBottom: 12,
              fontSize: 16,
              fontWeight: 600,
              color: "#374151",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <span role="img" aria-label="money">
              💰
            </span>{" "}
            Summary
          </h4>
        </div>
        {!!synopsis && (
          <div style={{ padding: 16 }}>
            <p
              style={{
                margin: "0 0 12px 0",
                lineHeight: 1.6,
                fontSize: 14,
                color: "#374151",
              }}
            >
              {synopsis}
            </p>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: 12,
                marginTop: 12,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 11,
                  padding: "6px 8px",
                  background: "#f8fafc",
                  borderRadius: 4,
                }}
              >
                <span style={{ color: "#64748b", fontWeight: 500 }}>
                  Confidence:
                </span>
                <span
                  style={{
                    color: "#1e293b",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  {formatConfidenceScore(confidenceScore)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 11,
                  padding: "6px 8px",
                  background: "#f8fafc",
                  borderRadius: 4,
                }}
              >
                <span style={{ color: "#64748b", fontWeight: 500 }}>
                  Freshness:
                </span>
                <span
                  style={{
                    color: "#1e293b",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  {dataFreshness || "N/A"}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 11,
                  padding: "6px 8px",
                  background: "#f8fafc",
                  borderRadius: 4,
                }}
              >
                <span style={{ color: "#64748b", fontWeight: 500 }}>
                  Updated:
                </span>
                <span
                  style={{
                    color: "#1e293b",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  {lastUpdated
                    ? new Date(lastUpdated).toLocaleDateString()
                    : "N/A"}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 11,
                  padding: "6px 8px",
                  background: "#f8fafc",
                  borderRadius: 4,
                }}
              >
                <span style={{ color: "#64748b", fontWeight: 500 }}>
                  Sources:
                </span>
                <span
                  style={{
                    color: "#1e293b",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: 120,
                  }}
                  title={sourcesText}
                >
                  {sourcesText.length > 20
                    ? sourcesText.substring(0, 17) + "..."
                    : sourcesText}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>

      {organizationRelevanceTable(
        relevance,
        potentialRisks,
        potentialOpportunities,
        organizationName
      )}

      {/* Stock Performance */}
      {stockCards.length > 0 && (
        <div
          style={{
            background: "white",
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            marginTop: 16,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: 16,
              background: "#eff6ff",
              borderBottom: "1px solid #bfdbfe",
            }}
          >
            <span style={{ color: "#2563eb", fontSize: 16 }}>📈</span>
            <h4
              style={{
                margin: 0,
                fontSize: 16,
                fontWeight: 600,
                color: "#2563eb",
              }}
            >
              Stock Performance
            </h4>
          </div>
          <div
            style={{
              padding: 16,
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: 12,
            }}
          >
            {stockCards}
          </div>
        </div>
      )}

      {/* Financial Fundamentals */}
      <FinancialFundamentalsTable
        annualEarnings={annualEarnings}
        annualGrowth={annualEarnings} // 12%
        quarterlyGrowth={quarterlyGrowth} // 3%
        epsGrowth={epsGrowth} // 8%
        lastEarningsDate={lastEarningsDate}
        nextEarningsDate={nextEarningsDate}
        quarterlyEarnings={quarterlyEarnings}
        riskLevel={riskLevel}
        keyRisks={keyRisks}
        opportunities={opportunities}
        marginsQuarterly={marginsQuarterly}
        revenueQuarterly={revenueQuarterly}
      />

      {/* Financial Statements */}
      {renderFinancialStatementsTable({
        incomeDate,
        incomeEbitda,
        incomeRevenue,
        incomeFinalLink,
        incomeNetIncome,
        incomeGrossProfit,
        incomeReportedDate,
        incomeOperatingIncome,
        cashFlowDate,
        cashFlowFinalLink,
        cashFlowFreeCashflow,
        cashFlowReportedDate,
        cashFlowFinancingCashflow,
        cashFlowInvestingCashflow,
        cashFlowOperatingCashflow,
        balanceSheetDate,
        balanceSheetFinalLink,
        balanceSheetTotalAssets,
        balanceSheetTotalEquity,
        balanceSheetReportedDate,
        balanceSheetRetainedEarnings,
        balanceSheetTotalLiabilities,
        balanceSheetCashAndEquivalents,
        isValidFieldAPI,
        formatCurrencyAPI,
      })}

      {/* Analyst Coverage */}
      {renderAnalystCoverageTable({
        totalAnalysts,
        priceTargetLow,
        priceTargetHigh,
        priceTargetUpside,
        priceTargetAverage,
        recommendationsBuy,
        recommendationsHold,
        recommendationsSell,
        recommendationsStrongBuy,
        recommendationsStrongSell,
        recentActions,
        isValidFieldAPI,
        formatCurrencyAPI,
        formatPercentageAPI,
      })}
    </div>
  );
}
